import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import UseCases from './components/UseCases';
import HowItWorks from './components/HowItWorks';
import CustomerJourney from './components/CustomerJourney';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import SecondaryCTA from './components/SecondaryCTA';
import Footer from './components/Footer';
import CookieConsent from './components/CookieConsent';
import AuthCallback from './components/AuthCallback';
import { LanguageProvider } from './hooks/useLanguage';
import { useAnimations } from './hooks/useAnimations';

function HomePage() {
  useAnimations(); // Initialize animations and interactions

  return (
    <>
      <Header />
      <Hero />
      <Features />
      <UseCases />
      <HowItWorks />
      <CustomerJourney />
      <FAQ />
      <Contact />
      <SecondaryCTA />
      <Footer />
      <CookieConsent />
    </>
  );
}

function App() {
  return (
    <LanguageProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="*" element={<HomePage />} />
          </Routes>
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;
